import { AiSearch } from './ai-search'
import { CircleAlertFilled } from './circle-alert-filled'
import { CircleCheckFilled } from './circle-check-filled'
import { SmartPhone } from './smart-phone'
import { TriangleAlertFilled } from './triangle-alert-filled'

export const SELECT_ICONS = {
  AiSearch,
  TriangleAlertFilled,
  CircleAlertFilled,
  CircleCheckFilled,
  SmartPhone,
} as const
